import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { anythingChanged } from '../../../utilities/common';
import messages from '../../../text/messages';
import WizardButtons from '../../wizard/navigator/buttons';

import './address.css';
import Address from '../../address';

class AddressForm extends React.Component {
    render() {
        const { handleSubmit, cancel, submitting, isPristine, form } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <Address form={form} />
                <div className="col-xs-12">
                    <WizardButtons
                        disabled={submitting || isPristine}
                        cancel={{ action: cancel }}
                        submit={{ message: <FormattedMessage {...messages.submit} /> }}
                    />
                </div>
            </form>
        );
    }
}

AddressForm.defaultProps = {
    handleSubmit: undefined,
    cancel: undefined
};

AddressForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    cancel: PropTypes.func
};

AddressForm = reduxForm({
    destroyOnUnmount: true,
    enableReinitialize: true,
    forceUnregisterOnUnmount: true
})(AddressForm);

const mapStateToProps = (state, props) => {
    const initialValues = props.initialValues;
    const formValues = getFormValues(props.form)(state);
    const isPristine = anythingChanged({ initialValues, values: formValues });

    return {
        initialValues: { country: 'US', ...initialValues },
        isPristine,
        formValues
    };
};

export default connect(mapStateToProps)(AddressForm);



// WEBPACK FOOTER //
// ./src/components/forms/address/index.jsx